<template>
<div>
  <b-row class="mb-2">
    <b-col class="text-sm-left">
      <div :class="eventStatusType(selectedEvent.event_status)" v-if="selectedEvent.event_status">
        <span class="regular-14 typo-color-white text-uppercase">
          {{selectedEvent.event_status}}
        </span>
      </div>
    </b-col>
  </b-row>
  <b-row class="mb-2">
    <b-col class="text-sm-left bold-24">
      <i v-if="!selectedEvent.visible" v-b-tooltip.hover.top="'SLMath Only'" class='fas fa-lock' />
      {{selectedEvent.name}}
    </b-col>
  </b-row>
  <b-row class="mb-2">
    <b-col class="text-sm-left regular-16 custom-html-text ">
      <span v-html="selectedEvent.teaser" />
    </b-col>
  </b-row>
  <b-row class="mb-4">
    <b-col>
      <router-link :to="{ name: `${pageName}`, params: { id: activeItemId }}">
        <button class="btn btn-primary btn-md">{{buttonName}}</button>
      </router-link>
    </b-col>
  </b-row>
  <b-row class="mb-2">
    <b-col class="text-sm-left regular-16">
      <organizer
        v-if="selectedEvent.organizers && selectedEvent.organizers_person_email_ids"
        :show-header="true"
        :organizers="selectedEvent.organizers"
        :organizers-email-ids="selectedEvent.organizers_person_email_ids.email_ids"
      />
    </b-col>
  </b-row>
</div>
</template>

<script>
import Organizer from '@/components/CommonPages/Organizer.vue'
import mixin from '@/utils/mixin.js'

export default {
 name: 'RightGridEventDetail',
 mixins: [mixin],
 components: { Organizer },
 props: ['selectedEvent', 'activeItemId', 'buttonName','pageName']
}
</script>
